export default __webpack_public_path__ + "media/images/mail/facebook_messenger-913bcee625f5b4ebbb4f4c65bac1ed60.png";